export const fileToImgSrc = (file: File) => {
    return URL.createObjectURL(file)
}